var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import { Button, Card, CardContent, CardHeader } from "@mui/material";
import { useDrop } from "react-dnd";
import { ItemTypes } from "../dnd/ItemTypes";
export var UnassignedTeamsDropZone = function (_a) {
    var children = _a.children, onNavigate = _a.onNavigate;
    var _b = __read(useDrop(function () { return ({
        accept: ItemTypes.TEAM,
        drop: function () {
            console.log("Drop event triggered in UnassignedTeamsDropZone");
            return { unassign: true };
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }); }), 2), _c = _b[0], canDrop = _c.canDrop, isOver = _c.isOver, drop = _b[1];
    var isActive = canDrop && isOver;
    return (_jsxs(Card, { ref: drop, sx: {
            backgroundColor: isActive
                ? "action.hover"
                : isOver
                    ? "action.selected"
                    : "background.paper",
            border: canDrop ? "2px dashed" : "1px solid",
            borderColor: isActive
                ? "primary.main"
                : canDrop
                    ? "primary.light"
                    : "divider",
            transition: "all 0.2s ease-in-out",
        }, children: [_jsx(CardHeader, { title: "Available Teams", titleTypographyProps: { variant: "h6" }, action: children && (_jsx(Button, { size: "small", onClick: function () {
                        onNavigate();
                    }, sx: { minWidth: "auto", p: 1 }, children: _jsx(AddIcon, {}) })), sx: { pb: 1 } }), _jsx(CardContent, { sx: { pt: 0 }, children: children })] }));
};
